import React, { useRef, useState, useContext } from 'react';
import './TopicSelector.css';
import ToggleSelector from '../ToggleTopicSelector';
import { TopicContext } from '../../context/topicContext';
import { DetailsContext } from '../../context/detailsContext';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { detectTransitionEndEventName } from '../../utils/detectEventName';
import classNames from 'classnames';
import { tracking, tagType } from '../../utils/tracking';
import { messages as text } from '../../messages';

const TopicSelector = React.memo(({ messages }) => {
  const transitionEndEventName = detectTransitionEndEventName();
  const {
    currentTopic,
    setCurrentTopic,
    setinitialOverview,
    numberOfCircles,
    isNavigationOpen,
    setIsNavigationOpen,
  } = useContext(TopicContext);
  const { setCurrentIndex, setViewDetails } = useContext(DetailsContext);

  const TopicTitles = [];
  const topicMessages = Object.entries(messages);
  let topicCounter = 1;

  // Loop through each topicMessages and look for Navtitle and use that for each menu label
  for (let index = 0; index < topicMessages.length; index++) {
    const topic = topicMessages[index][0];
    const title = topicMessages[index][1];
    if (topic === `topic.topic${topicCounter}NavTitle`) {
      TopicTitles.push(title);
      if (topicCounter > numberOfCircles) {
        break;
      } else {
        topicCounter = topicCounter + 1;
      }
    }
  }

  // const [isActive, setIsActive] = useState(false);
  const [toggleIsActive, setToggleIsActive] = useState(false);

  // Reference for nav element, used to detect transitionEND
  let navRef = useRef(undefined);

  // Toogle on/off nav and zoom in/out to topic, except if overview then go to initialoverview screen
  const toggleNav = (topicIndex, value = '') => {
    if (!isNavigationOpen) {
      setIsNavigationOpen(true);
      setToggleIsActive(true);
    } else {
      setIsNavigationOpen(false);

      navRef.current.addEventListener(
        transitionEndEventName,
        () => {
          setToggleIsActive(false);
          if (topicIndex !== undefined) {
            if (topicIndex === 'overview') {
              setinitialOverview(true);
              setCurrentTopic(undefined);
              setCurrentIndex(0);
              setViewDetails(false);

              tracking(
                tagType.event,
                text.topicOverviewTitle.defaultMessage,
                'In-page click',
                `${value}:Close`,
              );
            } else {
              tracking(
                tagType.event,
                text[`topic${topicIndex}Title`].defaultMessage,
                'In-page click',
                `${value}:Close`,
              );

              setCurrentTopic(topicIndex);
              setinitialOverview(false);
              setCurrentIndex(topicIndex);
              setViewDetails(true);
            }
          }
        },
        { once: true },
      );
    }
  };

  // Toggle active class when navigation is open
  const topicSelectorClassNames = classNames('topicSelector', {
    active: isNavigationOpen,
  });

  // Toggle active class for backdrop when navigation is open
  // Backdrop is a button that fills the remainder of the screen to be able to close nav when clicking outside it.
  const backdropClassNames = classNames('backdrop', {
    active: isNavigationOpen,
  });

  return (
    <>
      <ToggleSelector active={toggleIsActive} onClick={toggleNav} />
      <div ref={navRef} className={topicSelectorClassNames}>
        <button
          onClick={() =>
            toggleNav('overview', text.topicOverviewLabel.defaultMessage)
          }
          type="button"
          className={`item ${undefined === currentTopic && 'active'}`}>
          <span>
            <FormattedMessage id="topic.topicOverviewLabel" />
          </span>
        </button>
        {TopicTitles.map((value, key) => (
          <button
            key={key}
            onClick={() => toggleNav(key, value)}
            type="button"
            className={`item ${key === currentTopic && 'active'}`}>
            <span>{value}</span>
          </button>
        ))}
      </div>
      <button
        type="button"
        onClick={() => toggleNav()}
        className={backdropClassNames}></button>
    </>
  );
});

TopicSelector.displayName = 'TopicSelector';

TopicSelector.propTypes = {
  messages: PropTypes.object,
};

export default TopicSelector;
